import BaseValidator from 'services/validations/base-validator';

class MaxLockedPlayersValidator extends BaseValidator {
    private playersInLineup: number = 0;

    protected runValidation(): void {
        // @ts-ignore
        const {sportConfig} = this.dependencies;

        this.playersInLineup = sportConfig.getConfigProp('playersInTeam', 0);

        if (this.isLockedPlayersQuantityExceeded()) {
            this.addError(`You have more then  ${this.playersInLineup} players locked. Please Adjust.`);
        }
    }

    private isLockedPlayersQuantityExceeded(): boolean {
        // @ts-ignore
        const {playersLock} = this.dependencies;

        const lockedPlayersIds = playersLock.getMergedLockedPlayerIds();

        return lockedPlayersIds.length > this.playersInLineup;
    }
}

export {MaxLockedPlayersValidator};
